import { createContext, useContext, useState } from "react";
import { en } from "@/content/en";
import { es } from "@/content/es";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    try {
      return localStorage.getItem("cree8-lang") || "en";
    } catch {
      return "en";
    }
  });

  const toggleLanguage = () => {
    const newLang = language === "en" ? "es" : "en";
    setLanguage(newLang);
    try {
      localStorage.setItem("cree8-lang", newLang);
    } catch {}
  };

  const t = language === "en" ? en : es;

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage must be used within LanguageProvider");
  return context;
}
